<template>

  <div id="app">

    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-5" flat>

        <v-layout row wrap>

          <v-flex xs12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title class="baslikfont">{{$t('Statement-of-Account-by-Expense-Center')}}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search">

              </v-text-field>

              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> Mail Gönder

</v-btn>

              <v-menu offset-y>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>





                  <v-list-tile @click="openExcelLanguageDialog()" v-if="PB=='TRY'">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

 <!-- MAIL GÖNDER DIALOG -->

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>Mail Gönder</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              label="Kime (e-posta)"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              label="Agency Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              label="Doc Type (sabit)"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              label="Agent Full Name"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              label="Mesaj"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>Gönder

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>

          <v-container fluid>

            <v-layout row wrap>

              <v-flex xs12 sm6 md6 style="padding-right:2px;padding-bottom:2px;">

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">cached</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm4 md4>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('Total-Debit-v2') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm9 md8>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ currentDebtTotal | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm4 md4>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('Credit-Total') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm9 md8>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ currentCreditTotal | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>





                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="subheading font-weight-">{{ $t('Current-Period') }} : {{cariBakiye | bakiyekontrolsimgeli}} </span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>





              <v-flex xs12 sm6 md6 style="padding-right:2px;">

                <v-card color="#1E88E5" class="white--text">

                  <v-layout>

                    <v-flex xs2 sm2 md2>

                      <v-layout align-center="" justify-center="" fill-height="">

                        <v-icon color="white" large="">layers</v-icon>

                      </v-layout>

                    </v-flex>

                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm4 md4>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('Total-Debit-v2') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm9 md8>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ debtTotal | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>

                        <v-flex xs12 sm12 md12>

                          <v-layout>

                            <v-flex xs12 sm4 md4>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  {{ $t('Credit-Total') }}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                            <v-flex xs12 sm9 md8>

                              <v-list-tile-title>

                                <span class="subheading font-weight-">

                                  : {{ creditTotal | moneyformat }}{{getparabirimi()}}

                                </span>

                              </v-list-tile-title>

                            </v-flex>

                          </v-layout>

                        </v-flex>





                      </v-card-title>

                    </v-flex>

                  </v-layout>

                  <v-divider light></v-divider>

                  <v-card-actions class="pa-3">

                    <span class="subheading font-weight-">{{ $t('General-Balance') }} : {{genelBakiye | bakiyekontrolsimgeli}} </span>

                    <v-spacer></v-spacer>

                  </v-card-actions>

                </v-card>

              </v-flex>

            </v-layout>

            <v-card color="grey lighten-5" flat>

              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout pt-2 row wrap>

                  <v-flex xs12 sm6 md2>

                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false"

                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date"

                      v-model="date"></tarihcomp>

                  </v-flex>

                  <v-flex xs12 sm6 md2>

                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false"

                      :rules="[v => !!v || $t('Please-select-a-date')]" v-bind:defaultvalue="'ok'" v-bind:value="date2"

                      v-model="date2"></tarihcomp>

                  </v-flex>

                  <v-flex xs12 sm12 md3>

                    <v-autocomplete :items="MasrafMerkezi" clearable

                      :rules="[v => !!v || $t('Please-select-a-cost-center')]" :label="$t('Select-Expense-Centre')"

                      v-model="EkstreHesap.Masraf.Code" item-text="Title" item-value="Code">

                    </v-autocomplete>

                  </v-flex>

                  <v-flex>

                    <v-layout>

                      <div v-if="load1">

                        <v-btn color="info" @click="getList()" fab small="" dark>

                          <v-icon>search</v-icon>

                        </v-btn>

                      </div>





                      <v-badge color="white" :overlap="true">

                        <template v-slot:badge>

                          <v-icon v-if="filtrevarmi" large color="green">

                            check_circle_outline </v-icon>

                        </template>

                        <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"

                          @click="filtrele()" color="info" fab dark>

                          <v-icon>filter_list</v-icon>

                        </v-btn>

                        <v-tooltip bottom="" :activator="el" v-model="tooltip">

                          <span>{{$t('Add-Search-Filter')}}</span>

                        </v-tooltip>

                      </v-badge>

                    </v-layout>

                  </v-flex>





                  <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="400px">

                    <v-card color="grey lighten-2">

                      <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

                      <v-divider></v-divider>

                      <v-card-text>

                        <v-flex xs12 sm12 md12>

                          <v-layout justify-space-between column>

                          <cariaracomp v-bind:etiket="$t('Current-Account')" v-bind:value="EkstreHesap.Cari.Kod"

                           v-model="EkstreHesap.Cari.Kod"></cariaracomp>

                            <v-radio-group hide-details="" :label="$t('Report-Type-v2')" v-model="EkstreHesap.RaporTip" column>

                              <v-radio :label="$t('Only-Entered-Expense-Centre')" value="0">

                              </v-radio>

                              <v-radio :label="$t('Starting-with-the-Entered-Expense-Centre')" value="1"></v-radio>

                              <v-radio :label="$t('Including-the-Entered-Expense-Centre')" value="2"></v-radio>

                            </v-radio-group>

                            <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                          </v-layout>

                        </v-flex>

                      </v-card-text>

                      <v-divider></v-divider>

                      <v-card-actions>

                        <v-spacer></v-spacer>

                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

                      </v-card-actions>

                    </v-card>

                  </v-dialog>

                  <v-flex xs12 sm12 md12>

                    <v-card flat>

                      <v-card-title>

                        <v-spacer></v-spacer>

                      </v-card-title>

                      <div class="masraf-report-table">
                      <ReportTable
                        :headers="masrafReportHeaders"
                        :items="items"
                        storage-key="masrafmerkezinegore_columns"
                        :loading="progress"
                        :has-searched="items && items.length > 0"
                        :show-search="true"
                        :search-label="$t('Search')"
                        :show-frontend-export="true"
                        :export-title="$t('Statement-of-Account-by-Expense-Center')"
                        :export-meta-items="masrafExportMetaItems"
                        :export-summary-cards="masrafSummaryCards"
                        :rows-per-page-items="[50, 100, 250, 500, 1000]"
                      ></ReportTable>
                    </div>

                    </v-card>

                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'"

                      v-model="snackbar">

                      {{ text1 }}

                      <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

                    </v-snackbar>

                  </v-flex>

                </v-layout>

              </v-form>

            </v-card>

          </v-container>

        </v-layout>

      </v-card>





        <!-- EXCEL DİL SEÇİM DIALOG -->

        <v-dialog v-model="excelLanguageDialog" persistent max-width="420px">

            <v-card>

                <v-card-title class="headline">Excel</v-card-title>

                <v-card-text>

                    <v-select

                        :items="excelLanguages"

                        v-model="excelLanguage"

                        item-text="title"

                        item-value="locale"

                        label="Language"

                        hide-details

                    ></v-select>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>

                    <v-spacer></v-spacer>

                    <v-btn flat @click="closeExcelLanguageDialog">{{ $t('cancel_button') }}</v-btn>

                    <v-btn color="info" @click="downloadExcelWithLanguage">{{ $t('Download') }}</v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

</v-app>

  </div>

</template>





<script>

  import auth from '../../../api/auth'

  import helpers from "@/components/app/customcomp/helpers.js"

  import tarihcomp from '../customcomp/tarihim'

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import ReportTable from '@/components/app/customcomp/ReportTable.vue'
export default {

    data() {

      return {
            // Frontend Excel/HTML çıktısında eski ekstre üst bilgisini korumak için.
            exportSirketUnvani: '',

                excelLanguageDialog: false,

                excelLanguage: 'en',

                excelLanguages: [

                    { locale: 'tr', title: 'Türkçe' },

                    { locale: 'en', title: 'English' },

                    { locale: 'fr', title: 'Français' },

                    { locale: 'de', title: 'Deutsch' }

                ],



        mailDialog: false,

mailValid: false,

mailLoading: false,

mailPayload: {

  To: "",

  AgencyName: "",

  DocType: "Masraf Merkezine Göre Hesap Ekstresi - Statement of Account by Expense Center",

  AgentFullName: "",

  CustomBody: ""

},

rules: {

  required: v => !!v || 'Zorunlu alan',

  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'

},

        PB:'TRY',

        sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        filtrevarmi: false,

        cariBakiye: 0,

        genelBakiye: 0,

        search: '',

        valid: true,

        headers: [{

            text: this.$t('Date'),

            value: 'Date'

          },

          {

            text: this.$t('Currentcode_label'),

            value: 'Current',

            sortable: false

          },

          {

            text: this.$t('Document-Type'),

            value: 'DocumentType',

            sortable: false

          },

          {

            text: this.$t('Document-No'),

            value: 'DocumentNumber',

            sortable: false

          },

          {

            text: this.$t('Description'),

            value: 'Explanation',

            sortable: false

          },

          {

            text: this.$t('Maturity-Date'),

            value: 'DueDate',

            sortable: false

          },

          {

            text: this.$t('Debit'),

            value: 'Debt',

            align: 'right',

            sortable: false

          },

          {

            text: this.$t('Credit'),

            value: 'Credit',

            align: 'right',

            sortable: false

          }

        ],

        EkstreHesap: {

          SirketKodu: '',

          Masraf: {

            Code: ''

          },

          BaslangicTarih: '',

          BitisTarih: '',

          Cari: {

            Kod: ''

          },

          RaporTip: '0'

        },

        currentDebtTotal: 0,

        currentCreditTotal: 0,

        debtTotal: 0,

        creditTotal: 0,

        StartDate: null,

        EndDate: null,

        statecari: [],

        MasrafMerkezi: [],

        searchcari: '',

        dictionary: {

          custom: {

            masrafkodu: {

              required: () => this.$t('Please-select')

            },

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        evraktipi: [],

        anahesap: [],

        tumsirketler: '',

        date: null,

        menu: false,

        modal: false,

        dateFormatted: '',

        date2: null,

        menu2: false,

        dateFormatted2: '',

        modal2: false,

        loading: false,

        progress: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        tooltip: false,

        el: null,

      }

    },

    beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    components: {

      tarihcomp,

      yetkidialog,

      cariaracomp,
      ReportTable

    },

    computed: {
masrafReportHeaders() {
        return [
          { text: this.$t('Date'), value: 'Date', visible: true, sortable: true, type: 'date', align: 'left', width: '140px' },
          { text: this.$t('Currentcode_label'), value: 'Current', visible: true, sortable: true, type: 'text', align: 'left', width: '170px' },
          { text: this.$t('Document-Type'), value: 'DocumentType', visible: true, sortable: true, type: 'text', align: 'left', width: '150px' },
          { text: this.$t('Document-No'), value: 'DocumentNumber', visible: true, sortable: true, type: 'text', align: 'left', width: '160px' },
          { text: this.$t('Description'), value: 'Explanation', visible: true, sortable: true, type: 'text', align: 'left', width: '280px' },
          { text: this.$t('Maturity-Date'), value: 'DueDate', visible: true, sortable: true, type: 'date', align: 'left', width: '140px' },
          { text: this.$t('Debit'), value: 'Debt', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('Credit'), value: 'Credit', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' }
        ]
      },
      masrafExportMetaItems() {
        var reportType = this.EkstreHesap.RaporTip
        var first = this.items && this.items.length ? this.items[0] : null
        var cari = this.EkstreHesap && this.EkstreHesap.Cari ? (this.EkstreHesap.Cari.Kod || '') : ''
        if (!cari && first && first.Current) cari = first.Current
        if (first && first.CurrentTitle) cari += (cari ? ' - ' : '') + first.CurrentTitle

        return [
          { label: this.$t('Company-Title'), value: this.getExportCompanyTitle() },
          { label: this.$t('Starting-Date'), value: this.date, type: 'date' },
          { label: this.$t('Finishing-Date'), value: this.date2, type: 'date' },
          { label: this.$t('Select-Expense-Centre'), value: this.EkstreHesap && this.EkstreHesap.Masraf ? this.EkstreHesap.Masraf.Code : '' },
          { label: this.$t('Current-Account'), value: cari },
          { label: this.$t('Report-Type-v2'), value: reportType },
          { label: this.$t('All-Companies'), value: this.tumsirketler === true ? 'Evet' : 'Hayır' }
        ]
      },

      masrafSummaryCards() {
        return [
          {
            title: this.$t('Current-Period'),
            items: [
              { label: this.$t('Total-Debit-v2'), value: this.currentDebtTotal, type: 'money' },
              { label: this.$t('Credit-Total'), value: this.currentCreditTotal, type: 'money' },
              { label: this.$t('Current-Period'), value: this.cariBakiye, type: 'money' }
            ]
          },
          {
            title: this.$t('General-Balance'),
            items: [
              { label: this.$t('Total-Debit-v2'), value: this.debtTotal, type: 'money' },
              { label: this.$t('Credit-Total'), value: this.creditTotal, type: 'money' },
              { label: this.$t('General-Balance'), value: this.genelBakiye, type: 'money' }
            ]
          }
        ]
      }
    },

    watch: {

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      },

      bakiyekontrolsimgeli: function (m) {

        return helpers.bakiyekontrolsimgeli(m);

      }

    },

    mounted() {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.PB=credentials.ParaBirimi

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              let url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              let url = '#/'

              window.open(url, '_self')

            }

          }

        });

      }

    },

    methods: {
        getExportCompanyTitleFromCredentials() {
            try {
                var credentials = JSON.parse(window.localStorage.getItem('credentials') || '{}')
                return credentials.SirketUnvani ||
                    credentials.FirmaUnvani ||
                    credentials.SirketAdi ||
                    credentials.FirmaAdi ||
                    credentials.CompanyTitle ||
                    credentials.CompanyName ||
                    ''
            } catch (e) {
                return ''
            }
        },

        getExportCompanyTitle() {
            return this.exportSirketUnvani || this.getExportCompanyTitleFromCredentials() || ''
        },



            openExcelLanguageDialog() {

                var lang = localStorage.getItem('lang') || 'en';

                // Uygulamada kullanılan Deutsch-C+ dili Excel tarafında Almanca olarak indirilir.

                if (lang === 'deC') {

                    lang = 'de';

                }

                if (['tr', 'en', 'fr', 'de'].indexOf(lang) === -1) {

                    lang = 'en';

                }

                this.excelLanguage = lang;

                this.excelLanguageDialog = true;

            },

            closeExcelLanguageDialog() {

                this.excelLanguageDialog = false;

            },

            downloadExcelWithLanguage() {

                var lang = this.excelLanguage || 'en';

                if (['tr', 'en', 'fr', 'de'].indexOf(lang) === -1) {

                    lang = 'en';

                }

                this.excelLanguageDialog = false;

                this.getListExcel(lang);

            },



openMailDialog() {

  try {

    var credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};

    if (!this.mailPayload.AgentFullName && credentials.UserName) {

      this.mailPayload.AgentFullName = credentials.UserName;

    }

  } catch (e) {}

  this.mailDialog = true;

},

closeMailDialog() {

  this.mailDialog = false;

},

async sendMail() {

  if (!this.$refs.mailForm.validate()) return;

  var url = auth.API_URL + 'api/Abstract/MailGonderMasrafEkstre';

  var credentials = JSON.parse(window.localStorage.getItem('credentials')) || {};

  var basT = this.date ? String(this.date).slice(0, 10) : this.EkstreHesap.BaslangicTarih;

  var bitT = this.date2 ? String(this.date2).slice(0, 10) : this.EkstreHesap.BitisTarih;

  var input = {

    BaslangicTarih: basT,

    BitisTarih: bitT,

    Masraf: { Code: this.EkstreHesap.Masraf && this.EkstreHesap.Masraf.Code ? this.EkstreHesap.Masraf.Code : null },

    Cari:   { Kod: this.EkstreHesap.Cari && this.EkstreHesap.Cari.Kod ? this.EkstreHesap.Cari.Kod : null },

    RaporTip: this.EkstreHesap.RaporTip, // "0" | "1" | "2"

    SirketKodu: this.tumsirketler ? 0 : credentials.SirketKodu

  };

  var mail = {

    To: (this.mailPayload.To || '').trim(),

    AgencyName: (this.mailPayload.AgencyName || '').trim(),

    DocType: (this.mailPayload.DocType || '').trim(),

    AgentFullName: (this.mailPayload.AgentFullName || '').trim(),

    CustomBody: (this.mailPayload.CustomBody || '').trim()

  };

  var request = { Input: input, Mail: mail };

  this.mailLoading = true;

  try {

    await this.$http.post(url, request, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader(),

        'Content-Type': 'application/json'

      }

    });

    this.text1 = 'Mail gönderildi.';

    this.snackbar = true;

    this.closeMailDialog();

  } catch (err) {

    var body = err && err.body ? err.body : {};

    var msg = body.Message || body.message || 'Mail gönderilemedi.';

    this.text1 = msg;

    this.snackbar = true;

  } finally {

    this.mailLoading = false;

  }

},

      getparabirimi() {

        return helpers.getparabirimi()

      },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal,

    }

  }





  function filtrele() {

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.hesapgurubu = response.body

      this.progress = false

    }, (response) => {

      if (response.status === 0) {

        this.progress = false

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      } else {

        this.progress = false

        this.text1 = 'Service Unavailable'

        this.snackbar = true

      }

    })

  }









  function filtrekayit() {

    this.getList();

    this.filtrevarmi = true

    this.dialogfiltre = false

  }

  function filtreiptal() {

    this.filtrevarmi = false

    this.dialogfiltre = false

    this.EkstreHesap.Cari.Kod = null

    this.EkstreHesap.RaporTip = "0"

    this.tumsirketler = false

  }

  function getList() {





    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)

      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {

        this.progress = true

        this.currentDebtTotal = 0

        this.currentCreditTotal = 0

        this.debtTotal = 0

        this.creditTotal = 0





        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.EkstreHesap.SirketKodu = '0'

        } else {

          this.EkstreHesap.SirketKodu = credentials.SirketKodu

        }

        this.EkstreHesap.BaslangicTarih = this.date

        this.EkstreHesap.BitisTarih = this.date2

        var params = this.EkstreHesap

        this.$http.post(auth.API_URL + 'api/Abstract/ListWithExpenseCenter', params, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.items = response.body.List
          this.exportSirketUnvani =
            (response.body && response.body.SirketUnvani) ||
            this.getExportCompanyTitleFromCredentials()


          this.text1 = this.$t('Total') + " " + response.body.List.length + ' ' + this.$t('Number-of-Records-Found')

          this.snackbar = true

          this.cariBakiye = response.body.DonemBorc - response.body.DonemAlacak

          this.genelBakiye = response.body.ToplamBorc - response.body.ToplamAlacak

          this.currentCreditTotal = response.body.DonemAlacak

          this.debtTotal = response.body.ToplamBorc

          this.creditTotal = response.body.ToplamAlacak

          this.currentDebtTotal = response.body.DonemBorc

          this.progress = false

          this.load1 = true

        }, (response) => {

          if (response.status === 0) {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = 'Service Unavailable'

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

      } else {

        this.text1 = this.$t('start-date-cannot-greater-than-end-date')

        this.snackbar = true

      }

    }

  }

  function getListHtml() {

    this.progress = true

    this.currentDebtTotal = 0

    this.currentCreditTotal = 0

    this.debtTotal = 0

    this.creditTotal = 0









    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var lang = localStorage.getItem('lang')

    if (this.tumsirketler === true) {

      this.EkstreHesap.SirketKodu = '0'

    } else {

      this.EkstreHesap.SirketKodu = credentials.SirketKodu

    }

    this.EkstreHesap.BaslangicTarih = this.date

    this.EkstreHesap.BitisTarih = this.date2









    var params = this.EkstreHesap





    this.$http

      .post(auth.API_URL + "api/Abstract/ListWithExpenseCenterHtml", params, {

        headers: {

          Authorization: "Bearer " + auth.getAuthHeader()

        }

      }).then((response) => {

        if (lang=='en')

          {

             var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> MASRAF MERKEZİ EKSTRESİ </title>','<title> EXTRACT BY EXPENSE CENTERS </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>MASRAF MERKEZİ EKSTRESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>EXTRACT BY EXPENSE CENTERS</font>")

             response.bodyText=bodyhtml;

          }

        this.progress = false

        this.load1 = true

        var blob = new Blob([response.bodyText], {

          type: 'application/html'

        });

        var link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);

        link.download = this.$t('ExpenseExtract') + ".html";

        link.click();

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        } else {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        }

      })

  }





  function getListExcel(exportLang) {

    exportLang = exportLang || 'en'

    if (exportLang === 'deC') { exportLang = 'de' }

    if (['tr', 'en', 'fr', 'de'].indexOf(exportLang) === -1) { exportLang = 'en' }



    this.progress = true

    this.currentDebtTotal = 0

    this.currentCreditTotal = 0

    this.debtTotal = 0

    this.creditTotal = 0

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (this.tumsirketler === true) {

      this.EkstreHesap.SirketKodu = '0'

    } else {

      this.EkstreHesap.SirketKodu = credentials.SirketKodu

    }

    this.EkstreHesap.BaslangicTarih = this.date

    this.EkstreHesap.BitisTarih = this.date2









    var params = this.EkstreHesap





    this.$http

      .post(auth.API_URL + "api/Abstract/ListWithExpenseCenterExcel?lang=" + encodeURIComponent(exportLang), params, {

        headers: {

          Authorization: "Bearer " + auth.getAuthHeader()

        },

        responseType: "arraybuffer"

      }).then((response) => {

        this.progress = false

        this.load1 = true

        var blob = new Blob([response.data], {

          type: 'application/xlsx'

        });

        var link = document.createElement('a');

        link.href = window.URL.createObjectURL(blob);

        link.download = this.$t('ExpenseExtract') + ".xlsx";

        link.click();

      }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        } else {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

          this.progress = false

          this.load1 = true

        }

      })

  }





  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));





    var params = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.MasrafMerkezi = response.body

    }, (response) => {

        if (response.status === 0) {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

        } else {

          this.text1 = 'Service Unavailable'

          this.snackbar = true

        }

    })

  }

</script>

<style scoped>
.masraf-report-table { width: 100%; margin-top: 4px; }
.masraf-report-table > * { width: 100%; }
</style>
